export default ({ request }) => ({
  userReimbursementListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/list',
      method: 'post',
      data,
    })
  },
  userReimbursementSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/save',
      method: 'post',
      data,
    })
  },
  userReimbursementDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/detail',
      method: 'post',
      data,
    })
  },
  userReimbursementDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/del',
      method: 'post',
      data,
    })
  },
  userReimbursementRejectedApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/force/reject',
      method: 'post',
      data,
    })
  },
  userReimbursementCheckInvoiceApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/check/invoice',
      method: 'post',
      data,
    })
  },
  userReimbursementNoInvoiceApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/no/invoice',
      method: 'post',
      data,
    })
  },
  userReimbursementSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/user/reimbursement/apply',
      method: 'post',
      data,
    })
  },
  userReimbursementItemListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/item/list',
      method: 'post',
      data,
    })
  },
  userReimbursementDocistApi(data = {}) {
    return request({
      url: '/digitalCenter/user/reimbursement/doc/list',
      method: 'post',
      data,
    })
  },
})
